module.exports = __webpack_public_path__ + "fonts/DroidSans-Bold.62c11ac.woff";